let filterFields = [];
let allowedFilterIds = {
  curriculum: new Set(),
  grade: new Set(),
  subject: new Set(),
};

export function setFilterRegistry({ fields = [], allowedIds = null } = {}) {
  filterFields = fields;
  allowedFilterIds = allowedIds ?? {
    curriculum: new Set(),
    grade: new Set(),
    subject: new Set(),
  };
}

export function getFilterFields() {
  return filterFields;
}

export function getAllowedFilterIds() {
  return allowedFilterIds;
}

export function clearFilterRegistry() {
  filterFields = [];
  allowedFilterIds = {
    curriculum: new Set(),
    grade: new Set(),
    subject: new Set(),
  };
}
